<template>
  <!-- Document -->
  <div v-if="category == data_document.section_id || category == 0 "
    class="col-md-4 col-sm-6 col-xs-1 images ag mb-4 dlnkdocs_section px-2" :class="'dlnkdocs_section_' + data_document.section_id">

    <div class="card card-frame h-100" href="#">
      <div class="card-body pb-3 pt-4">
        <div class="row">
          <figure class="w-100 mb-3 col-3">
            <span class="text-primary"><i class="far fa-file-image fa-3x"></i></span>
          </figure>
          <div class="text-right col-9">
            <small class="d-block text-default mt-1"> <span class="text-dark">{{ data_document.author.name }}</span></small>
            <small class="d-block text-default mt-1">le <span class="text-dark">{{ data_document.created_date_fr_short }}</span></small>
            <small v-if="admin && data_document.file==='file not found'" class="d-block text-default mt-1">
              <span class="text-dark">{{ data_document.filename }}</span>
            </small>
          </div>
        </div>

        <h4 class="cbp-l-grid-projects-title">{{ data_document.title }}</h4>
        <p class="font-size-1 text-body mb-0">{{ data_document.description }}</p>

      </div>
      <div class="card-footer border-0 pt-0 ml-2 mr-2">
        <div class="row">
          <a class="btn btn-sm btn-soft-primary btn-pill transition-3d-hover col-12" :href="data_document.file"
             v-if="data_document.kind === 'file'" download="">
            <i class="fas fa-download"></i>&nbsp;Télécharger
          </a>

          <a data-fancybox class="btn btn-sm btn-soft-primary btn-pill transition-3d-hover col-12"
             :href="data_document.video_url" v-if="data_document.kind === 'video'">
            <i class="fas fa-eye"></i>&nbsp;Visionner
          </a>

          <a class="btn btn-sm btn-soft-primary btn-pill transition-3d-hover col-12" :href="data_document.internet_url"
             v-if="data_document.kind === 'internet'" target="_blank">
            <i class="fas fa-link"></i>&nbsp;Voir
          </a>

        </div>
      </div>

      <div v-if="!!admin && view_settings" class="card-footer border-0 pt-0 ml-2 mr-2">
        <div class="row">
          <a @click='edit_document()'   class="btn btn-sm btn-soft-dark btn-pill transition-3d-hover col-3" href="javascript:"><i class="fas fa-cogs"></i></a>
          <a @click='delete_document()' class="btn btn-sm btn-soft-danger btn-pill transition-3d-hover col-3" href="javascript:" download=""><i class="fas fa-trash"></i></a>
          <a @click='document_down()'   class="btn btn-sm btn-soft-dark btn-pill transition-3d-hover col-3" href="javascript:"><i class="fas fa-arrow-down"></i></a>
          <a @click='document_up()'     class="btn btn-sm btn-soft-dark btn-pill transition-3d-hover col-3" href="javascript:"><i class="fas fa-arrow-up"></i></a>
        </div>
      </div>

    </div>
  </div>
  <!-- End Document -->
</template>

<script>
    export default {
      props: {
        document: {
          type: Object,
          default() {
            return {}
          }
        },
        view_settings: {
          type: Boolean,
          default: true
        },
        document_id: Number,
        category: Number,
        admin: Boolean,
        company: Object,
      },

      data: function () {
        return {
          data_document: {
            author: {}
          },
        }
      },

      mounted() {
        const _this = this

        if( Object.keys(_this.document).length === 0 && _this.document.constructor === Object) {
          _this.get_document()
        } else {
          _this.data_document = _this.document
        }
        
      },

      methods: {

        document_down: function () {
          this.$emit('document_down', this.data_document.id)
        },

        document_up: function () {
          this.$emit('document_up', this.data_document.id)
        },

        edit_document: function () {
          this.$emit('edit_document', this.data_document)
        },

        delete_document: function () {
          if (confirm('Attention, êtes-vous certain de vouloir supprimer ce document.')) {
            this.$emit('delete_document', this.data_document.id)
          }
        },

        get_document: function () {
          const _this = this
          get_token_2().then(function (response) {
            let group = ''
            let [secure_key, customer_id, api_url, customer] = response
            api_url += `documents/${_this.document_id}.json`
            api_url += '?secure_key=' + secure_key
            api_url += '&customer_id=' + customer_id

            axios.get(api_url)
                .then(function (response) {
                  _this.data_document = response.data.document
                })
                .catch(function (error) {
                  console.log(error)
                })
                .then(function () {
                });
          })
        },
      }
    }
</script>

